import { api } from "api/api";
import { AxiosError } from "axios";
import Produto from "model/administracao/cadastro/produto/Produto";
import Deposito from "model/suprimentos/Deposito";
import Transacao from "model/suprimentos/Transacao";
import AjusteEstoque from "model/suprimentos/AjusteEstoque";
import EstoqueLote from "model/suprimentos/EstoqueLote";


class AjusteEstoqueService {

    ajustar(ajusteEstoque: AjusteEstoque) {
        return new Promise<void>((resolve, reject): void => {
            api
                .post(`/ajusteEstoque/ajustar`, JSON.stringify(ajusteEstoque))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });

    }

    getDepositos() {
        return new Promise<Array<Deposito>>((resolve, reject): void => {
            api
                .get(`/ajusteEstoque/depositos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getTransacoes(tipo:string) {
        return new Promise<Array<Transacao>>((resolve, reject): void => {
            api
                .get(`/ajusteEstoque/transacoes/${tipo}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getProdutosDisponiveis(deposito: Deposito) {
        return new Promise<Array<Produto>>((resolve, reject): void => {
            api
                .get(`/ajusteEstoque/produtosDisponiveis/${deposito.codigo}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getTodosProdutos() {
        return new Promise<Array<Produto>>((resolve, reject): void => {
            api
                .get(`/ajusteEstoque/produtosDisponiveis`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getLotesDisponiveis(deposito: Deposito, produto: Produto) {
        return new Promise<Array<EstoqueLote>>((resolve, reject): void => {
            api
                .get(`/ajusteEstoque/lotesDisponiveis/${deposito.codigo}/${produto.codigo}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    } 
    
    getValorUnitario(lote: EstoqueLote) {
        return new Promise<number>((resolve, reject): void => {
            api
                .get(`/ajusteEstoque/valorUnitario/${encodeURIComponent(lote.produto.codigo as string)}/${encodeURIComponent(lote.lote as string)}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getTransacaoPadrao(tipo: string): Promise<Transacao> {
        return new Promise<Transacao>((resolve, reject): void => {
            api
                .get(`/ajusteEstoque/transacaoPadrao/${tipo}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getTiposTransacao() {
        return [
            { label: 'Entrada', value: 'ENTRADA' }, 
            { label: 'Saída', value: 'SAIDA' }
        ]
    }

    getTipoTransacao(tipo: string) {
        if (tipo === 'ENTRADA') {
            return 'Entrada';
        } else if (tipo === 'SAIDA') {
            return 'Saída';
        }
        return '';
    }

    

}

export default AjusteEstoqueService;